const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/utils/styling.ts';
export const FREEZE_SCROLLING_CLASS = 'dynamic-scrolling-freeze';

export const setStyleForClass = (classname: string, key: string, value: string | undefined) => {
    const elementsWithClass = document.querySelectorAll(`.${classname}`);

    elementsWithClass.forEach((element: any) => {
        element.style[key] = value ? value : null;
    });
};

export const freezeScrolling = () => {
    setStyleForClass(FREEZE_SCROLLING_CLASS, 'overflow', 'hidden');
};

export const unfreezeScrolling = () => {
    setStyleForClass(FREEZE_SCROLLING_CLASS, 'overflow', undefined);
};
